import React from 'react';
import { Form, Upload, Button } from 'antd';

type InputFileProps = {
  validateFile?:
  | ''
  | 'error'
  | 'success'
  | 'warning'
  | 'validating'
  | undefined;
  required?: boolean;
  handleChangeFile?: (e: any) => void;
  value?: any;
  label: string;
  accept?: string;
  placeholder?: string;
  error?: string;
  extra?: string;
  disabled?: boolean;
  multiple?: boolean;
};

export default function InputMultipleFile({
  required = false,
  validateFile,
  handleChangeFile = () => undefined,
  value,
  label,
  accept,
  placeholder = 'Click to Upload',
  error = 'File Wajib diisi',
  extra,
  disabled = false,
  multiple = true,
}: InputFileProps) {
  const fileList = Array.isArray(value) ? value : [];
  const selectedSingleFile = !multiple && fileList.length ? fileList[0] : null;
  const buttonText = selectedSingleFile
    ? selectedSingleFile.name || selectedSingleFile.fileName
    : placeholder;

  // console.log(value)
  return (
    <div>
      <span>
        <b>{label}</b>
      </span>
      <Form.Item
        validateStatus={required ? validateFile : ''}
        help={required && validateFile === 'error' ? error : ''}
        style={{ margin: 0 }}
        extra={extra}
      >
        <Upload
          accept={accept}
          multiple={multiple}
          fileList={
            fileList.length
              ? fileList.map((file, index) => ({
                uid: `${index}`,
                name: file.name || file.fileName,
                status: 'done',
                size: file.size || file.file?.size || 0,
                type: file.type || file.file?.type || '',
                url: '',
              }))
              : []
          }
          beforeUpload={() => false}          
          onRemove={fileToRemove => {
            const updated = (value || []).filter((file) => {
              return file.name !== fileToRemove.name || file.size !== fileToRemove.size;
            });

            handleChangeFile(updated);
          }}
          onChange={e => {
            const newFiles = e.fileList
              .map(f => f.originFileObj)
              .filter(f => f instanceof File);

            const existingFiles = Array.isArray(value) ? value : [];

            const allFiles = (multiple ? [...existingFiles, ...newFiles] : newFiles).filter(
              (file, index, self) =>
                index === self.findIndex(f => f.name === file.name && f.size === file.size)
            );

            handleChangeFile(multiple ? allFiles : allFiles.slice(-1));
          }}
          showUploadList={multiple}
          disabled={disabled}
        >
          <Button
            icon={'upload'}
            style={{
              width: '100%',
              height: 32,
              borderRadius: 10,
              display: 'flex',
              flexDirection: 'row-reverse',
              alignItems: 'center',
              justifyContent: 'space-between',
              overflow: 'hidden',
            }}
            disabled={disabled}
          >
            <span
              style={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                paddingRight: 8,
              }}
              title={buttonText}
            >
              {buttonText}
            </span>
          </Button>
        </Upload>
      </Form.Item>
    </div>
  );
}
